'use strict';
import angular from 'angular';

angular.module('calendar.services', [])

    .factory('CalendarService', ['IORestangular', '$q', '$http', function (IORestangular, $q, $http) {
        var slotTypes = IORestangular.all('slots/slotTypes');
        var adSizes = IORestangular.all('lookups/adSizes');
        var slotType = IORestangular.all('slots/slotType');
        var slotMappings = IORestangular.all('slots/slotMappingsForSlotType');
        var slotMapping = IORestangular.all('slots/slotMapping');
        var slots = IORestangular.all('slots/slot');
        var allSlots = IORestangular.all('slots/tree');
        var websites = IORestangular.all('lookups/websitePlacements');
        var sections = IORestangular.all('lookups/websiteSections');
        var lookupsTypes = IORestangular.all('lookups/types');
        var lookupsContents = IORestangular.all('lookups/contents');

        var getSlotTypes = function () {
            return slotTypes.customGET(undefined, undefined, undefined, undefined);
        };

        var getAdSizes = function (clusterObj) {
            return adSizes.customGET(undefined, clusterObj, undefined, undefined);
        };

        var addSlotType = function (slotTypeObj) {
            return slotType.customPOST(slotTypeObj, undefined, undefined, undefined);
        }

        var updateSlotType = function (slotTypeObj) {
            return slotType.customPUT(undefined, undefined, slotTypeObj, undefined);
        };

        var deleteSlotType = function (slotTypeObj) {
            return slotType.remove(slotTypeObj);
        };

        var getSlotMappingsForSlotType = function (slotTypeObj) {
            return slotMappings.customGET(undefined, slotTypeObj, undefined, undefined);
        };

        var addSlotMapping = function (slotMappingObj) {
            return slotMapping.customPOST(slotMappingObj, undefined, undefined, undefined);
        }

        var updateSlotMapping = function (slotMappingObj) {
            return slotMapping.customPUT(undefined, undefined, slotMappingObj, undefined);
        };

        var deleteSlotMapping = function (slotMappingObj) {
            return slotMapping.remove(slotMappingObj);
        };

        var getSlots = function (clusterObj) {
            return allSlots.customGET(undefined, clusterObj, undefined, undefined);
        };

        var addSlots = function (slotsObj) {
            return slots.customPOST(slotsObj, undefined, undefined, undefined);
        }

        var addSlot = function (slotObj) {
            //return slotType.customPOST(slotObj, undefined, undefined, undefined);
        };

        var updateSlot = function (slotObj) {
            return slots.customPOST(slotObj, undefined, undefined, undefined);
        };

        var deleteSlot = function (slotObj) {
            return slots.remove(slotObj);
        };

        var getSections = function (clusterObj) {
            return sections.customGET(undefined, clusterObj, undefined, undefined);
        };

        var getWebsites = function (clusterObj) {
            return websites.customGET(undefined, clusterObj, undefined, undefined);
        };

        var getLookupTypes = function () {
            return lookupsTypes.customGET(undefined, undefined, undefined, undefined);
        };

        var getLookupContents = function (paramObj) {
            return lookupsContents.customGET(undefined, paramObj, undefined, undefined);
        };

        return {
            getSlotTypes: getSlotTypes,
            getAdSizes: getAdSizes,
            addSlotType: addSlotType,
            updateSlotType: updateSlotType,
            deleteSlotType: deleteSlotType,
            getSlotMappingsForSlotType: getSlotMappingsForSlotType,
            addSlotMapping: addSlotMapping,
            updateSlotMapping: updateSlotMapping,
            deleteSlotMapping: deleteSlotMapping,
            getSlots: getSlots,
            addSlots:addSlots,
            addSlot: addSlot,
            updateSlot: updateSlot,
            deleteSlot: deleteSlot,
            getSections: getSections,
            getWebsites: getWebsites,
            getLookupTypes: getLookupTypes,
            getLookupContents: getLookupContents
        };
    }]);